import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Wix from '../../../app/services/wix-sdk-polyfill';
import styles from './profile-content-frame.scss';

class ProfileContentFrame extends React.Component {
  state = {
    componentVisible: true,
  };

  constructor(props) {
    super(props);

    this.titleRef = React.createRef();
  }

  showComponent = () => this.setState({ componentVisible: true });
  hideComponent = () => this.setState({ componentVisible: false });

  componentDidMount() {
    this.focusOnTitle();

    Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, this.showComponent);
    Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, this.hideComponent);
  }

  componentDidUpdate(prevProps, prevState) {
    const { componentVisible } = this.state;

    if (prevState.componentVisible !== componentVisible) {
      if (componentVisible) {
        this.focusOnTitle();
      }
    }
  }

  componentWillUnmount() {
    Wix.removeEventListener(Wix.Events.PAGE_NAVIGATION_IN, this.showComponent);
    Wix.removeEventListener(Wix.Events.PAGE_NAVIGATION_OUT, this.hideComponent);
  }

  focusOnTitle = () => {
    // TODO update after out of iframe, timeout is needed for accessibility audio indication on focus to work
    setTimeout(() => {
      this.titleRef.current && this.titleRef.current.focus();
    }, 2000);
  };

  render() {
    const {
      actions,
      children,
      className,
      contentClassName,
      title,
      titleClassName,
      titleFontClassName,
      headerClassName,
    } = this.props;

    return (
      <div className={classNames(styles.container, className)}>
        <div className={classNames(styles.header, headerClassName)}>
          <h2
            ref={this.titleRef}
            tabIndex="0"
            className={classNames(
              titleClassName,
              'page-title-color',
              'page-title-font',
              styles.title,
              titleFontClassName,
            )}
          >
            {title}
          </h2>
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
        <div className={contentClassName}>{children}</div>
      </div>
    );
  }
}

ProfileContentFrame.propTypes = {
  actions: PropTypes.any,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  titleFontClassName: PropTypes.string,
  headerClassName: PropTypes.string,
};

export default ProfileContentFrame;
